import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getPlans, setAdvancementPayMethod } from "../../store/actions";
import { Link, Redirect } from "react-router-dom";
import styled from "styled-components";
import HeaderPlans from "../organisms/HeaderPlans";
import BodyPlans from "../organisms/BodyPlans";
import ModalCardLoader from "../molecules/ModalCardLoader";
import { executeTaggeo } from "../../store/actions";
import ServiceNotAvalible from "../organisms/ServiceNotAvalible";
import OfferTelcelWithoutLine from "../organisms/OfferTelcelWithoutLine";
import { CATEGORY_PLANS_ID_PAQUETE_AMIGO_SIN_LIMITE, CATEGORY_PLANS_ID_PAQUETE_INTERNET_POSPAGO, CATEGORY_PLANS_ID_PAQUETE_INTERNET_POSPAGO_MIXTO, SERVICE_ID_TELCEL_PAQUETES_MIXTOS, SERVICE_ID_TELCEL_PAQUETES_POSPAGO } from "../../constants";
import { getUserInfoSelector } from "../../store/selectors/paymentsSelectors";
import { getPaymentFlowForTaggeo, getRequirementsAdvancementClaroPay } from "../organisms/utils";
import ModalInApp from "../molecules/ModalInApp";

const Container = styled.div`
  width: 100%;
  overflow: scroll;
  background: ${(props) => (props.background ? props.background : "#f7f8f8")};
  min-height: 100vh;
`;

class PlansContainer extends Component {
  constructor(props) {
    super(props);
    const { paymentMethods } = this.props;

    const isAnonimous =
      this.props.isAnonimous ||
      (this.props.isContainerTelcel && paymentMethods &&
        paymentMethods.cardList.length === 0 &&
        !paymentMethods.hasN2)
        ? true
        : false;

    this.state = {
      serviceDataGeneric:
        this.props.paymentsConfig.services[this.props.serviceConfigIndex]
          .serviceData.generic,
      serviceDataInfo:
        this.props.paymentsConfig.services[this.props.serviceConfigIndex]
          .serviceData.info,
      offerTelcel: !isAnonimous
        ? this.props.paymentsConfig.services[this.props.serviceConfigIndex]
            .offerTelcel
        : this.props.paymentsConfig.services[this.props.serviceConfigIndex]
            .offerTelcelAnonimo,
      disableSeeMoreButton: false,
      isAnonimous: isAnonimous,
    };
  }

  componentDidMount() {
    if (
      this.state.serviceDataInfo.categoryId === 8 ||
      this.state.serviceDataInfo.categoryId === 32 ||
      this.state.serviceDataInfo.categoryId === CATEGORY_PLANS_ID_PAQUETE_INTERNET_POSPAGO ||
      this.state.serviceDataInfo.categoryId === CATEGORY_PLANS_ID_PAQUETE_INTERNET_POSPAGO_MIXTO
    ) {
      this.setState({ disableSeeMoreButton: true });
    } else {
      let params = {
        action: "View",
        step: this.state.serviceDataInfo.serviceTitleLabel,
        service: this.props.tagServiceId,
      };

      if (this.props.isContainerTelcel) {
        const msisdn = this.props.paymentsConfig ? this.props.paymentsConfig.msisdn : undefined;
        const flow = getPaymentFlowForTaggeo(
          this.props.isAnonimous, 
          msisdn, 
          this.props.paymentMethods
        );

        params = { ...params, flow };
      }
      this.props.executeTaggeo(params);
    }
    this.props.getPlans(
      this.state.serviceDataInfo.serviceId,
      this.state.serviceDataInfo.categoryPlansId
        ? this.state.serviceDataInfo.categoryPlansId
        : this.state.serviceDataInfo.categoryId
    );

  }

  componentDidUpdate(prevProps) {
    const { plans, goToMicroappAdelanto, paramsFromurl } = this.props;
    if (prevProps.plans !== plans) {
      if (goToMicroappAdelanto || (paramsFromurl && paramsFromurl.goToMicroappAdelanto )) {
        this.validateFromAdelanto();
      } else {
        this.openPackage();
      }

      if (
        (
          this.state.serviceDataInfo.serviceId === SERVICE_ID_TELCEL_PAQUETES_POSPAGO &&
          this.state.serviceDataInfo.categoryId === CATEGORY_PLANS_ID_PAQUETE_INTERNET_POSPAGO          
        ) ||
        (
          this.state.serviceDataInfo.serviceId === SERVICE_ID_TELCEL_PAQUETES_MIXTOS ||
          this.state.serviceDataInfo.categoryId === CATEGORY_PLANS_ID_PAQUETE_INTERNET_POSPAGO_MIXTO
        )
      ) {
        let params = {
          action: "View",
          step: "Paquetes Internet por tiempo para tu Plan",
          service: this.props.tagServiceId,
        };
  
        if (this.props.isContainerTelcel) {
          const msisdn = this.props.paymentsConfig ? this.props.paymentsConfig.msisdn : undefined;
          const flow = getPaymentFlowForTaggeo(
            this.props.isAnonimous, 
            msisdn, 
            this.props.paymentMethods
          );
  
          params = { ...params, flow };
        }
        this.props.executeTaggeo(params);
      }
    }
  }

  openPackage = () => {
    const {
      history,
      plans,
      isContainerTelcel,
      paramsNewOfferTelcel,
      tagServiceId,
      sdkVersion,
      paymentsConfig,
      isClaroPartner,
      paramsFromurl,
      serviceConfigIndex,
    } = this.props;
    if (paramsFromurl && paramsFromurl.actionMA) {
      const packageInit = plans.detail.find(
        (item) => item.cost === parseInt(paramsFromurl.paymentAmount)
      );
      if (packageInit && packageInit.idExternal) {
        history.replace({
          pathname: "/plans",
          state: {
            sdkVersion: sdkVersion,
            paymentsConfig: paymentsConfig,
            isClaroPartner: isClaroPartner,
            amountPlan: paramsFromurl.paymentAmount,
            productId: packageInit.idExternal,
            serviceConfigIndex: serviceConfigIndex,
            tagServiceId: tagServiceId,
            paramsNewOfferTelcel: paramsNewOfferTelcel,
            isContainerTelcel: isContainerTelcel,
            idCategory: plans.service.id,
            mb: packageInit.mb,
            isAdvancementClaroPay: true,
          },
        });
      }
    }
  };

  validateFromAdelanto = () => {
    const {
      history,
      plans,
      isContainerTelcel,
      paramsNewOfferTelcel,
      tagServiceId,
      sdkVersion,
      paymentsConfig,
      isClaroPartner,
      goToMicroappAdelanto,
      paymentAmountFromUrl,
      serviceConfigIndex,
      paramsFromurl
    } = this.props;

    if (goToMicroappAdelanto || paramsFromurl.goToMicroappAdelanto) {
      console.log("entra2");
      const planAmount = isContainerTelcel ? paramsFromurl.paymentAmount : paymentAmountFromUrl
      const fiftyPlan = plans.detail.filter(
        (item) => item.cost === parseInt(planAmount)
      )[0];
      history.push({
        pathname: "/plans",
        state: {
          sdkVersion: sdkVersion,
          paymentsConfig: paymentsConfig,
          isClaroPartner: isClaroPartner,
          amountPlan: planAmount,
          productId: fiftyPlan.idExternal,
          serviceConfigIndex: serviceConfigIndex,
          tagServiceId: tagServiceId,
          paramsNewOfferTelcel: paramsNewOfferTelcel,
          isContainerTelcel: isContainerTelcel,
          idCategory: plans.service.id,
          mb: fiftyPlan.mb,
          isAdvancementClaroPay: true,
        },
      });
    }
  };

  handleButonSeeMore = () => {
    this.setState({ disableSeeMoreButton: true });
  };

  executeTaggeoHandle = (cost, productId, typeButton) => {
    const { executeTaggeo, setAdvancementPayMethod } = this.props;
    const { serviceTitleLabel, categoryPlansId } = this.state.serviceDataInfo;

    const step = (
      categoryPlansId === CATEGORY_PLANS_ID_PAQUETE_INTERNET_POSPAGO || 
      categoryPlansId === CATEGORY_PLANS_ID_PAQUETE_INTERNET_POSPAGO_MIXTO
    )
      ? "Paquetes Internet por tiempo para tu Plan"
      : serviceTitleLabel

    let params = {
      action: "Click Lo quiero",
      step,
      service: this.props.tagServiceId,
    };

    if (this.props.isContainerTelcel) {
      const msisdn = this.props.paymentsConfig ? this.props.paymentsConfig.msisdn : undefined;
      const flow = getPaymentFlowForTaggeo(
        this.props.isAnonimous, 
        msisdn, 
        this.props.paymentMethods
      );

      params = { ...params, flow, package: String(cost) };
    }

    if (typeButton === "adelanto") {
      params.action = "Click Usar Adelanto";
      params.step = "Paquetes Telcel";
      setAdvancementPayMethod(true)
    }
    executeTaggeo(params);
  };

  render() {
    const {
      errorPlans,
      paramsNewOfferTelcel,
      isContainerTelcel,
      isClaroPartner,
      userInfo,
    } = this.props;
    const {
      offerTelcel,
      serviceDataInfo: { categoryPlansId, withOfferTelcel, canShowModalInApp },
      isAnonimous
    } = this.state;
    let title = "";
    let subtitle = "";
    let idService = ""
    let planId = ""
    if (this.props.plans) {
      title = this.props.plans.service.title;
      subtitle = this.props.plans.service.subtitle;
      idService = this.props.plans && this.props.plans.service && this.props.plans.service.idService
      planId = this.props.plans && this.props.plans.service && this.props.plans.service.id
    } 

    return (
      <>
        {errorPlans ? (
          <ServiceNotAvalible />
        ) : (
          <Container
            background={
              isContainerTelcel && !isClaroPartner ? "#f6f6f6" : "#f7f8f8"
            }
          >
            <HeaderPlans
              dataConfigLogo={this.state.serviceDataGeneric.logo.data}
              titlePlans={title}
              subtitlePlans={subtitle}
              isContainerTelcel={isContainerTelcel}
              isClaroPartner={isClaroPartner}
              idService={idService}
              planId={planId}
              isLoadingGetPlans={this.props.isLoadingGetPlans}
            />
            <BodyPlans
              plans={this.props.plans}
              disableSeeMoreButton={this.state.disableSeeMoreButton}
              handleButonSeeMore={this.handleButonSeeMore}
              paymentsConfig={this.props.paymentsConfig}
              sdkClaroVersion={this.props.sdkVersion}
              isClaroPartner={this.props.isClaroPartner}
              serviceConfigIndex={this.props.serviceConfigIndex}
              tagServiceId={this.props.tagServiceId}
              paymentMethod={
                paramsNewOfferTelcel
                  ? paramsNewOfferTelcel.creditCardInfo
                  : false
              }
              approvedToAdvancementClaroPay={getRequirementsAdvancementClaroPay(
                userInfo,
                isContainerTelcel,
                idService
              )}
              executeTaggeoHandle={this.executeTaggeoHandle}
              paramsNewOfferTelcel={paramsNewOfferTelcel}
              withOfferTelcelWithoutLine={
                categoryPlansId ===
                  CATEGORY_PLANS_ID_PAQUETE_AMIGO_SIN_LIMITE || withOfferTelcel
              }
              isContainerTelcel={this.props.isContainerTelcel}
              isAnonimous={isAnonimous}
            />
            {categoryPlansId === CATEGORY_PLANS_ID_PAQUETE_AMIGO_SIN_LIMITE ||
            withOfferTelcel ? (
              <OfferTelcelWithoutLine
                offerTelcel={offerTelcel}
                planType={""}
                history={this.props.history}
                subtitleAlign={"left"}
                subtitleMargin={"5% 0% 2% 5%"}
                logoIsVisible={"none"}
                subtitle={"Descubre otras opciones"}
                step={this.state.serviceDataInfo.serviceTitleLabel}
                event={"pay_service_or_tae"}
                isContainerTelcel={isContainerTelcel}
                isClaroPartner={isClaroPartner}
                quitPlanType={true}
              />
            ) : (
              <></>
            )}
          </Container>
        )}
        <ModalCardLoader isOpen={this.props.isLoadingGetPlans} />
        <ModalInApp canShowModalInApp={canShowModalInApp} categoryPlansId={categoryPlansId}/>
      </>
    );
  }
}

function mapStateToProps(state) {
  const userInfo = getUserInfoSelector(state);

  return {
    paymentMethods: state.payments.paymentMethods,
    plans: state.payments.plans,
    isLoadingGetPlans: state.payments.isLoadingGetPlans,
    errorPlans: state.payments.errorPlans,
    isAnonimous: state.payments.isAnonimous,
    userInfo: userInfo,
    paymentAmountFromUrl: state.payments.getPaymentAmountFromUrl,
    productId: state.payments.getProductIdFromUrl,
    goToMicroappAdelanto: state.payments.goToMicroappAdelanto,
    paramsFromurl: state.payments.params,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getPlans,
      executeTaggeo,
      setAdvancementPayMethod
    },
    dispatch
  );
}

PlansContainer = connect(mapStateToProps, mapDispatchToProps)(PlansContainer);

export default PlansContainer;
